package com.milta.core.localization

data class SubscriptionStrings(
    val screenTitle: String,
    val screenSubtitle: String,
    val planDriver: String,
    val planOrganisation: String,
    val statusActive: String,
    val statusTrial: String,
    val statusExpired: String,
    val statusCancelled: String,
    val platformLabel: String,
    val productIdLabel: String,
    val expiresAtLabel: String,
    val noExpiry: String,
    /** Fallback shown for a technical detail row with no value (e.g. a Trial row's platform/product — locale-invariant "—"). */
    val noValue: String,
    val noSubscription: String,
    val activateButton: String,
    val successActivated: String,
    val perMonth: String,
    // Offer pitch (no active subscription)
    val pitchTitle: String,
    val pitchSubtitle: String,
    val featuredBadge: String,
    val driverFeature1: String,
    val driverFeature2: String,
    val driverFeature3: String,
    val orgFeature1: String,
    val orgFeature2: String,
    val orgFeature3: String,
    val orgFeature4: String,
    val purchaseFinePrint: String,
    val purchasingLabel: String,
    // Active subscription
    val activeCaption: String,
    val nextRenewalLabel: String,
    val includedTitle: String,
    val manageOnGooglePlay: String,
    val manageOnAppStore: String,
    val viewTechnicalDetails: String,
    val monthNames: List<String>,
    // Error messages
    val errorNotFound: String,
    val errorConflict: String,
    val errorPlanMismatch: String,
    val errorPlanRequired: String,
    val errorPlanInvalid: String,
    val errorPlatformRequired: String,
    val errorPlatformInvalid: String,
    val errorStoreProductIdRequired: String,
    val errorReceiptTokenRequired: String,
    val errorGeneric: String,
    // Free-trial banner (Accueil/Tournées, top of screen) — MIL trial-then-subscription feature.
    /** Prefix before the bold "X jours" segment, >48h remaining. */
    val trialBannerDaysPrefix: String,
    /** Bold segment, contains a "%d" placeholder for the whole number of days remaining (rounded up). */
    val trialBannerDaysBold: String,
    /** Suffix after the bold "X jours" segment. */
    val trialBannerDaysSuffix: String,
    /** Prefix before the bold "Xh" segment, <=48h remaining. */
    val trialBannerHoursPrefix: String,
    /** Bold segment, contains a "%d" placeholder for the whole number of hours remaining (rounded up). */
    val trialBannerHoursBold: String,
    /** Suffix after the bold "Xh" segment. */
    val trialBannerHoursSuffix: String,
)
